import React = require('react');
import { Button } from 'react-bootstrap';
import { ErrorDisplay } from '../FieldFormControl/ErrorDisplay';

export const ButtonAsRadio = ({
                                input,
                                simpleValue,
                                className,
                                disabled = false,
                                handleChange = null,
                                secondaryClass = 'admiral-secondary-btn',
                                selectedText,
                                unSelectedText,
                                isBlock,
                                style,
                                meta,
                                validationMessage
                              }) => {

  const classes = className + (meta.dirty ? ' dirty-field' : '') + (meta.touched && meta.error ? ' has-error' : '');

  const onClickChange = () => () => {
    input.onChange(input.value = simpleValue);
    if (handleChange) {
      handleChange(simpleValue);
    }
  }

  const isSelected = input.value === simpleValue;
  const component = (
    <div style={style}>
      <Button
        style={style}
        className={isSelected ? (secondaryClass) : classes}
        onClick={onClickChange()}
        disabled={disabled}
        block={isBlock}
        value={simpleValue}>
        {isSelected ? selectedText : unSelectedText}
      </Button>
    </div>
  )

  return (
    <div className={meta.touched && meta.error ? 'has-error' : ''}>
      {component}
      {validationMessage !== 'single' && (
        <>
          {meta.touched && meta.error && <ErrorDisplay error={meta.error}/>}
        </>
      )}
    </div>
  );
}
